import { MouseEvent, ReactNode } from "react";

export interface ButtonProps {
	disabled?: boolean;
	title?: string;
	id?: string;
	onClick?: (e?: MouseEvent) => void;
	className?: string;
	types?: ButtonTypes[];
	color?: ButtonColor;
	size?: ButtonSize;
	fullWidth?: boolean;
	type?: "button" | "submit" | "reset";
	children?: ReactNode;
	tabIndex?: number;
}

export enum ButtonTypes {
	Primary,
	Danger,
	Green,
	Circle,
	Text,
	Warning,
	Outline,
}

export enum ButtonColor {
	DarkBlue,
	Red,
	Green,
	DarkGreen,
	LightBlue,
	DarkYellow,
}

export enum ButtonSize {
	small,
	medium,
	large,
}
